module.exports = __webpack_public_path__ + "img/villa_dialog_icon05.3ab5217d.png";